import isVerifyTokenGuard from "@/guards/verifyTokenGuard";

export default {
    name: 'vaccinations-scheme',
    component: () => import(/* webpackChunkName: "base-layout" */ '@/layouts/BaseLayout.vue'),
    children: [
        {
            path: '',
            name: 'vaccinations-scheme-index',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [
                    {                           
                        transKey: 'breadcrumbs.vaccinations-scheme-index',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "vaccinations-scheme-index" */ '@/modules/configurations/catalogs/vaccinations-scheme/views/Index.vue')
        },
        {
            path: 'create',
            name: 'vaccinations-scheme-create',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [
                    {   
                        route: {
                            name: 'vaccinations-scheme-index',
                            params: {}
                        },
                        transKey: 'breadcrumbs.vaccinations-scheme-index',
                        isActive: false
                    },
                    {                           
                        transKey: 'breadcrumbs.vaccinations-scheme-create',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "vaccinations-scheme-create" */ '@/modules/configurations/catalogs/vaccinations-scheme/views/Create.vue')
        },
        {
            path: 'edit/:id',
            name: 'vaccinations-scheme-edit',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [
                    {   
                        route: {
                            name: 'vaccinations-scheme-index',
                            params: {}
                        },
                        transKey: 'breadcrumbs.vaccinations-scheme-index',
                        isActive: false
                    },
                    {                           
                        transKey: 'breadcrumbs.vaccinations-scheme-edit',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "vaccinations-scheme-edit" */ '@/modules/configurations/catalogs/vaccinations-scheme/views/Edit.vue')
        }
    ]
}